import React from 'react'
import { Alert, List } from 'antd'

class FormErrorMessage extends React.Component {
  render() {
    if (this.props.error.length === 0) return null
    return (
      <Alert
        message={this.props.error.length + ' error prohibited this piece from being saved:'}
        description={
          <List dataSource={this.props.error} renderItem={(item) => <List.Item key={item.errors[0]}>{item.errors[0]}</List.Item>} />
        }
        type='error'
        showIcon
        style={{ marginTop: '16px' }}
      />
    )
  }
}

export default FormErrorMessage
